import { render, staticRenderFns } from "./fccSubGrupos.vue?vue&type=template&id=3105f984"
import script from "./fccSubGrupos.vue?vue&type=script&lang=js"
export * from "./fccSubGrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports